import { Link } from "react-router-dom";

export const DigitizationAndEdtechConst = {
  path: "/single-page/digitization-and-edtech",
  title: "ЦИФРОВИЗАЦИЯ И EDTECH",
  contentJSX: (
    <>
      <h2>ЦИФРОВИЗАЦИЯ И EDTECH</h2>
      <p>Общий объем: 144 академических часа</p>
      <p>Формат: онлайн / гибрид</p>
      <p>Язык: русский / английский / узбекский</p>
      <p>Итог: Международный сертификат</p>
      <h2>I. EDTECH-ЭКОСИСТЕМА И ЦИФРОВЫЕ ОБРАЗОВАТЕЛЬНЫЕ ПЛАТФОРМЫ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Moodle, Canvas, Google Classroom: обзор и интеграция – 12 ч</li>
        <li>Интерактивные инструменты: Padlet, Mentimeter, Quizizz – 12 ч</li>
        <li>Цифровая трансформация курсов и онлайн-методология – 12 ч</li>
      </ul>
      <h2>II. ИНТЕРАКТИВНЫЕ ТЕХНОЛОГИИ И МУЛЬТИМЕДИА — 30 ЧАСОВ</h2>
      <ul className="number">
        <li>Геймификация и игровое обучение – 6 ч</li>
        <li>Использование визуальных редакторов и mindmaps – 6 ч</li>
        <li>Внедрение AR/VR в обучение – 6 ч</li>
        <li>Создание цифровых учебных материалов – 6 ч</li>
        <li>Адаптивное обучение и персонализация контента – 6 ч</li>
      </ul>
      <h2>III. DATA-DRIVEN ОБУЧЕНИЕ — 24 ЧАСА</h2>
      <ul className="number">
        <li>Learning Analytics и визуализация результатов – 12 ч</li>
        <li>Использование AI-трекинга и интеллектуальных платформ – 12 ч</li>
      </ul>
      <h2>IV. ЦИФРОВАЯ ГРАМОТНОСТЬ И ЭТИКА — 18 ЧАСОВ</h2>
      <ul className="number">
        <li>Навыки цифрового взаимодействия – 6 ч</li>
        <li>Безопасность данных и конфиденциальность – 6 ч</li>
        <li>Цифровая этика и академическая честность в онлайне – 6 ч</li>
      </ul>
      <h2>ИТОГОВЫЙ ПРОЕКТ: РАЗРАБОТКА ОНЛАЙН-МОДУЛЯ — 36 ЧАСОВ</h2>
      <ul className="number">
        <li>Проектирование, реализация, обратная связь – 18 ч</li>
        <li>Презентация и peer-review – 18 ч</li>
      </ul>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    ЦИФРОВИЗАЦИЯ И EDTECH 
    Общий объем: 144 академических часа
    Формат: онлайн / гибрид
    Язык: русский / английский / узбекский
    Итог: Международный сертификат
    I. EDTECH-ЭКОСИСТЕМА И ЦИФРОВЫЕ ОБРАЗОВАТЕЛЬНЫЕ ПЛАТФОРМЫ — 36 ЧАСОВ
    Moodle, Canvas, Google Classroom: обзор и интеграция – 12 ч
    Интерактивные инструменты: Padlet, Mentimeter, Quizizz – 12 ч
    Цифровая трансформация курсов и онлайн-методология – 12 ч
    II. ИНТЕРАКТИВНЫЕ ТЕХНОЛОГИИ И МУЛЬТИМЕДИА — 30 ЧАСОВ
    Геймификация и игровое обучение – 6 ч
    Использование визуальных редакторов и mindmaps – 6 ч
    Внедрение AR/VR в обучение – 6 ч
    Создание цифровых учебных материалов – 6 ч
    Адаптивное обучение и персонализация контента – 6 ч
    III. DATA-DRIVEN ОБУЧЕНИЕ — 24 ЧАСА
    Learning Analytics и визуализация результатов – 12 ч
    Использование AI-трекинга и интеллектуальных платформ – 12 ч
    IV. ЦИФРОВАЯ ГРАМОТНОСТЬ И ЭТИКА — 18 ЧАСОВ
    Навыки цифрового взаимодействия – 6 ч
    Безопасность данных и конфиденциальность – 6 ч
    Цифровая этика и академическая честность в онлайне – 6 ч
    V. ИТОГОВЫЙ ПРОЕКТ: РАЗРАБОТКА ОНЛАЙН-МОДУЛЯ — 36 ЧАСОВ
    Проектирование, реализация, обратная связь – 18 ч
    Презентация и peer-review – 18 ч
  `,
};
